export function formatMoney (value, emptyText = '--') {
  if (value === null || value === undefined || value === '') {
    return emptyText
  }
  const amount = Number(value)
  return Number.isFinite(amount) ? `¥${amount.toFixed(2)}` : emptyText
}
